var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07471 0.755859C2.58065 0.755859 1.35824 1.97827 1.35824 3.47233V4.83057H0V10.2635H8.14941V4.83057H6.79118V3.47233C6.79118 1.97827 5.56877 0.755859 4.07471 0.755859ZM4.07471 2.1141C4.83532 2.1141 5.43294 2.71172 5.43294 3.47233V4.83057H2.71647V3.47233C2.71647 2.71172 3.3141 2.1141 4.07471 2.1141Z",
    fill: "#0D2045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c516bf015638f91e9cfe40969f6e439f.svg";
export { ForwardRef as ReactComponent };